import debug from 'bows/dist/bows.min.js';
import $ from "jquery";

const log = debug("general");

function breadcrumbFix() {

  let path = document.referrer.replace(window.location.origin, '').replace(/\/([^\/#?]*).*/, '$1');
  let breadcrumb = document.getElementById('block-breadcrumbs').querySelector('.breadcrumb__item');
  if (breadcrumb) {
    let breadcrumb_link = breadcrumb.querySelector('a');
    let breadcrumb_label = breadcrumb.querySelector('a span');
    switch (path) {
      case 'exhibitions-events':
        breadcrumb_label.innerText = ' Exhibitions & Events';
        breadcrumb_link.href = 'javascript:history.back()';
        break;
      case 'exhibitions':
        breadcrumb_label.innerText = ' Exhibitions';
        breadcrumb_link.href = 'javascript:history.back()';
        break;
      case 'events':
        breadcrumb_label.innerText = ' Events';
        breadcrumb_link.href = 'javascript:history.back()';
        break;
    }
    if (breadcrumb.baseURI.includes('activity-4-10')) {
      breadcrumb_label.innerText = ' What is Collecting?';
      breadcrumb_link.href = '/collecting-interactive';
    }
  }
}

export function init() {
  if (document.body.classList.contains('page--event') || document.body.classList.contains('page-node-7629')) {
    breadcrumbFix();
  }
}

export default {
  init
};
